export const calculateTotalPosts = (data) => {
  if (!Array.isArray(data)) {
    console.error("Invalid data passed to calculateTotalPosts:", data);
    return 0;
  }

  return data.reduce((sum, item) => sum + (Array.isArray(item.posts) ? item.posts.length : 0), 0);
};

export const calculateTotalReactions = (data) => {
  if (!Array.isArray(data)) {
    console.error("Invalid data passed to calculateTotalReactions:", data);
    return 0;
  }

  return data.reduce(
    (sum, item) =>
      sum +
      (Array.isArray(item.posts)
        ? item.posts.reduce(
          (postSum, post) =>
            postSum +
            (post.postMetrics?.likes || post.postMetrics?.like || 0) +
            (post.postMetrics?.love || 0) +
            (post.postMetrics?.wow || 0) +
            (post.postMetrics?.haha || 0) +
            (post.postMetrics?.sad || 0) +
            (post.postMetrics?.angry || 0),
          0
        )
        : 0),
    0
  );
};

// [NEW] Metrics
export const calculateTotalImpressions = (data) => {
  if (!Array.isArray(data)) return 0;
  return data.reduce((sum, item) => sum + (Number(item.pageMetrics?.page_media_view) || 0), 0);
};

export const calculateTotalReach = (data) => {
  if (!Array.isArray(data)) return 0;
  return data.reduce((sum, item) => sum + (Number(item.pageMetrics?.page_impressions_unique) || 0), 0);
  // Note: specific days sum != unique for period, but this is the best scalar proxy 
};

export const calculateTotalVideoViews = (data) => {
  if (!Array.isArray(data)) return 0;
  return data.reduce((sum, item) => sum + (Number(item.pageMetrics?.page_media_view) || 0), 0);
};

export const calculateTotalProfileViews = (data) => {
  if (!Array.isArray(data)) return 0;
  return data.reduce((sum, item) => sum + (Number(item.pageMetrics?.page_views_total) || 0), 0);
};
